/* Copyright (c) 2021-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

const TITLE_WIDTH = "11rem";

export const DetailsItem = styled.div`
  display: flex;
  column-gap: ${theme.spacing.spacing02};
  margin-bottom: ${theme.spacing.spacing02};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailsTitle = styled.div`
  display: flex;
  width: ${TITLE_WIDTH};
  min-width: ${TITLE_WIDTH};
  word-break: break-all;
  color: ${theme.color.text.text02};
`;

export const DetailsDescription = styled.div`
  display: flex;
  align-items: center;
  word-break: break-all;
`;
